import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75fd28ac&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=75fd28ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fd28ac",
  null
  
)

export default component.exports